import script from "./CartGiftCardPriceItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartGiftCardPriceItem.vue?vue&type=script&setup=true&lang=ts"

import "./CartGiftCardPriceItem.vue?vue&type=style&index=0&id=27cf1364&lang=css"

const __exports__ = script;

export default __exports__